const CGV = () => {
  return (
    <>
      <span className="text-lg font-semibold">Conditions Générales de Vente (CGV)</span>
      <br />
      Date de mise à jour : 8 septembre 2025
      <br />
      <br />
      <span className="text-lg font-semibold">Préambule</span>
      <br />
      Les présentes Conditions Générales de Vente (ci-après « CGV ») régissent les relations contractuelles entre :
      <ul className="list-disc ml-6">
        <li>
          Le Comité Interprofessionnel pour le Développement de la Formation dans le domaine des Marchandises Dangereuses (CIFMD), association loi 1901, siège social : 14 rue de la République, 92800 Puteaux, SIRET 422 669 861 00029, non assujettie à la TVA,
        </li>
        <li>
          Et toute personne physique inscrivant un candidat à un examen en son nom propre (ci-après « le Candidat »).
        </li>
      </ul>
      L’acceptation expresse et préalable de ces CGV est une condition indispensable pour finaliser l’inscription. Elle est recueillie via l’interface web d’inscription, qui impose leur lecture complète avant validation.
      <br />
      <br />
      <span className="text-lg font-semibold">Article 1 – Objet et champ d’application</span>
      <br />
      1. Les présentes CGV s’appliquent à la vente des prestations de service suivantes : organisation et réalisation des examens initiaux et de renouvellement du certificat de Conseiller à la Sécurité pour le Transport des Marchandises Dangereuses (CSTMD), par route, rail ou voie navigable, ainsi que les prestations associées (inscription en ligne, déroulement des épreuves à distance, délivrance des certificats).
      <br />
      2. Les conditions d’utilisation technique et réglementaire de la plateforme d’examen sont détaillées dans les Conditions Générales d’Utilisation (CGU), qui doivent également être acceptées au moment de l’inscription.
      <br />
      3. Les CGV sont disponibles sur{" "}
      <a className="text-blue-500" href="https://www.cifmd.org" target="_newPage">
        www.cifmd.org
      </a>{" "}
      et consultables à tout moment dans l’espace candidat.
      <br />
      4. Le CIFMD peut modifier les présentes CGV à tout moment. La version applicable est celle acceptée à la date de validation de l’inscription.
      <br />
      <br />
      <span className="text-lg font-semibold">Article 2 – Nature et caractéristiques de la prestation</span>
      <br />
      1. Le CIFMD est l’unique organisme habilité en France à organiser les examens CSTMD conformément à l’arrêté du 6 février 2019 en vigueur.
      <br />
      2. Les prestations sont intégralement dématérialisées : inscription en ligne via la plateforme sécurisée, déroulement des épreuves à distance via la plateforme Managexam, délivrance électronique du certificat.
      <br />
      3. Les dates de session sont publiées sur le site du CIFMD. Le candidat doit répondre à tous les prérequis d’inscription définis dans les CGU.
      <br />
      4. En cas de non-respect de ces conditions, aucun remboursement n’est effectué. Sur demande écrite et dûment justifiée, un report unique et gracieux vers la session suivante peut être accordé.
      <br />
      <br />
      <span className="text-lg font-semibold">Article 3 – Processus d’inscription et validation</span>
      <br />
      1. L’inscription à l’examen est effectuée exclusivement par le candidat lui-même via son compte personnel sur la plateforme d’inscription en ligne.
      <br />
      2. En cas de délégation, le délégataire (employeur ou tiers désigné) n’intervient que pour le paiement via un compte entreprise dédié, sans possibilité de procéder à l’inscription à la place du candidat.
      <br />
      3. Lors de son inscription, le candidat choisit le périmètre du certificat (mode(s) de transport et classe(s) de danger concernés) et la date de session.
      <br />
      4. Avant validation, le candidat peut vérifier et corriger les informations fournies ainsi que le montant total dû.
      <br />
      5. La validation définitive de l’inscription intervient uniquement après paiement intégral des frais d’inscription en vigueur (publiés sur le site et dans l’espace candidat) et réception d’un e-mail de confirmation.
      <br />
      6. Toute préinscription non réglée avant la date de clôture publiée sur le site et dans l’espace candidat est automatiquement annulée.
      <br />
      <br />
      <span className="text-lg font-semibold">Article 4 – Tarifs et modalités de paiement</span>
      <br />
      1. Les tarifs des prestations sont exprimés en euros et non soumis à la TVA.
      <br />
      2. Les moyens de paiement acceptés sont : carte bancaire via la plateforme sécurisée, virement bancaire (prise en compte après confirmation de réception).
      <br />
      3. Les paiements par chèque ou bons de commande ne sont pas acceptés.
      <br />
      4. En l’absence de paiement intégral avant la date de clôture, l’inscription est annulée.
      <br />
      5. Le CIFMD, en tant qu’association, ne délivre pas de facture commerciale mais émet une note de débit. Cette note de débit est disponible dans l’espace candidat, et celui du délégataire s’il y en a, et constitue le seul document comptable fourni. Elle peut être produite à titre de preuve du contrat.
      <br />
      <br />
      <span className="text-lg font-semibold">Article 5 – Rétractation, résiliation et report</span>
      <br />
      1. Droit de rétractation : conformément aux articles L. 221-18 et suivants du Code de la consommation, le candidat dispose de 14 jours à compter de la validation de l’inscription pour se rétracter, sans motif ni pénalité.
      <br />
      2. L’exercice du droit de rétractation se fait par courrier recommandé avec accusé de réception et par courriel à{" "}
      <a className="text-blue-500" href="mailto:contact@cifmd.fr" target="_newPage">
        contact@cifmd.fr
      </a>
      , avant l’expiration du délai.
      <br />
      3. Le remboursement ou le report est effectué sous 14 jours à compter de la réception de la demande.
      <br />
      4. Passé le délai légal de rétractation, l’inscription devient ferme et définitive et aucun remboursement n’est possible, sauf en cas de force majeure (au sens de l’article 1218 du Code civil et selon les CGU).
      <br />
      5. En cas de force majeure, le CIFMD propose un report gratuit vers la session suivante, sans remboursement.
      <br />
      6. Un report volontaire (hors force majeure) est possible avant la date de clôture des inscriptions, sur simple demande écrite. Aucun report n’est possible après ce délai.
      <br />
      <br />
      <span className="text-lg font-semibold">Article 6 – Propriété intellectuelle</span>
      <br />
      1. Le CIFMD détient la propriété exclusive des sujets d’examen (non communiqués aux candidats, sauf exemples publiés sur le site) et des contenus des applications et supports d’évaluation.
      <br />
      2. Toute reproduction, modification ou diffusion non autorisée est interdite et expose son auteur à des poursuites judiciaires.
      <br />
      3. Le candidat transfère au CIFMD :
      <ul className="list-disc ml-6">
        <li>La propriété de sa copie numérique d’étude de cas (examen initial uniquement) ;</li>
        <li>La propriété de sa copie numérique de QCM et des réponses qu’il a apportées.</li>
      </ul>
      4. Ces éléments sont utilisés par le CIFMD à des fins de :
      <ul className="list-disc ml-6">
        <li>Correction des épreuves (après anonymisation, pour les copies d’études de cas) ;</li>
        <li>Retour d’expérience pédagogique ;</li>
        <li>Élaboration de statistiques internes ;</li>
        <li>Archivage réglementaire et technique.</li>
      </ul>
      <br />
      <span className="text-lg font-semibold">Article 7 – Force majeure</span>
      <br />
      1. Constitue un cas de force majeure pour le candidat tout événement imprévisible, irrésistible et indépendant de sa volonté rendant impossible sa participation à l’examen (hospitalisation, sinistre, intempéries exceptionnelles, panne majeure, pandémie…).
      <br />
      2. Constitue un cas de force majeure pour le CIFMD tout événement extérieur empêchant l’organisation ou la réalisation d’une session, ou entraînant la perte ou la corruption de données indispensables (catastrophe naturelle, décision administrative, cyberattaque, panne réseau ou infrastructure).
      <br />
      3. En cas de force majeure du CIFMD, un report gratuit vers une nouvelle session est organisé dans les meilleurs délais, ou des mesures correctives nécessaires à la reprise des examens sont mises en œuvre, sans frais supplémentaires ni indemnité pour les candidats.
      <br />
      <br />
      <span className="text-lg font-semibold">Article 8 – Loi applicable et juridiction compétente</span>
      <br />
      1. Les présentes CGV sont soumises au droit français.
      <br />
      2. Tout litige relatif à leur interprétation ou leur exécution, à défaut de résolution amiable, sera porté devant le Tribunal de commerce de Paris.
      <br />
      <br />
      <span className="text-lg font-semibold">Annexe – Formulaire-type de rétractation</span>
      <br />
      Document disponible via les présentes CGV publiées sur notre site{" "}
      <a className="text-blue-500" href="https://www.cifmd.org" target="_newPage">
        www.cifmd.org
      </a>
      .
    </>
  );
};

export default CGV;

